import { images } from '../../../Constants/ImageUrls';
import OvulationCategories from '../OvulationCategories/OvulationCategories';
import {
  lateOvulation,
  lateOvulationSymptoms,
  ovulationData,
  ovulationEffect,
  whenToDoctor,
} from '../staticData';
import ProductCarousel from './ProductCarousel/ProductCarousel';
import {
  ContentContainer,
  ListedBelow,
  ListedBelowSection,
  OvulationHeading,
  OvulationImageGrid,
  OvulationPara,
  PurpleListSection,
} from './styled';

export default function OvulationToolContent() {
  return (
    <>
      <ContentContainer>
        {ovulationData?.map((data, index) => {
          return (
            <div key={index}>
              <OvulationHeading>{data.heading}</OvulationHeading>
              <OvulationPara>{data?.content}</OvulationPara>
              {data?.nextPara && (
                <OvulationPara>{data?.nextPara}</OvulationPara>
              )}
            </div>
          );
        })}

        <div>
          <OvulationHeading>
            How to calculate ovulation period?
          </OvulationHeading>
          <OvulationPara>
            Just jot down the start date of your last menstrual cycle and
            ovulation will take place between the 10th-14th day from that date.
            This calculation is easy and simple but can&apos;t always be
            accurate:{' '}
          </OvulationPara>
          <OvulationCategories />

          <OvulationImageGrid>
            <img src={images.days35} alt="35days" />
            <img src={images.thirtyTwoDays} alt="32days" />
            <img src={images.twentyEightDays} alt="28days" />
            <img src={images.twentyFourDays} alt="24days" />
          </OvulationImageGrid>
        </div>
        <ListedBelowSection>
          <OvulationHeading padding>
            Late Ovulation: Causes, Symptoms &amp; Effect
          </OvulationHeading>
          <h4>Causes</h4>
          <ListedBelow>
            Ovulation can be late or absent due to an imbalance in your hormones
            but that doesn&apos;t mean that you&apos;re infertile. If you
            ovulate between days 21-35 of your cycle, then you might have no
            clue about your next menstrual cycle. If you&apos;re stressed and
            wondering if there are any chances of getting pregnant after a
            delayed or late ovulation, then you don&apos;t have to worry. Most
            of the time tracking your menstrual cycle and ovulation window can
            be a daunting task and for that, you can take help from a fertility
            expert.
            <br /> Let&apos;s find out what causes late ovulation:
          </ListedBelow>
        </ListedBelowSection>

        <PurpleListSection>
          <ul>
            {lateOvulation?.map((data, index) => {
              return (
                <li key={index}>
                  <h4>{data?.heading}</h4>
                  <p>{data?.content}</p>
                </li>
              );
            })}
          </ul>
        </PurpleListSection>

        <div>
          <ListedBelowSection>
            {' '}
            <h4>Symptoms</h4>
            <ListedBelow>
              Some of the common symptoms of delayed or late ovulation are:{' '}
            </ListedBelow>
          </ListedBelowSection>

          <PurpleListSection>
            <ul>
              {lateOvulationSymptoms?.map((data, index) => {
                return (
                  <li key={index}>
                    <h4>{data?.heading}</h4>
                    <p>{data?.content}</p>
                  </li>
                );
              })}
            </ul>
          </PurpleListSection>
        </div>

        <div>
          <ListedBelowSection>
            {' '}
            <h4>Effects</h4>
            <ListedBelow>
              After knowing about the causes and common symptoms of late
              ovulation, let&apos;s find out how does it affects conception and
              fertility:
            </ListedBelow>
          </ListedBelowSection>

          <PurpleListSection>
            <ul>
              {ovulationEffect?.map((data, index) => {
                return (
                  <li key={index}>
                    <p>{data?.content}</p>
                  </li>
                );
              })}
            </ul>
          </PurpleListSection>
        </div>

        <div>
          {' '}
          <OvulationHeading>When should you see a doctor? </OvulationHeading>
          <OvulationPara>
            Many couples are hesitant to visit a gynecologist &amp; obstetrician
            because they lack knowledge and don&apos;t know when they should
            consult one. You should consult a fertility expert if:
          </OvulationPara>
          <PurpleListSection>
            <ul>
              {whenToDoctor?.map((data, index) => {
                return (
                  <li key={index}>
                    <p>{data?.content}</p>
                  </li>
                );
              })}
            </ul>
          </PurpleListSection>
        </div>
      </ContentContainer>
      <ProductCarousel />
    </>
  );
}
